import React from "react";
import { Card } from "@mui/material";

import Box from "themeComponents/Box";
import Typography from "themeComponents/Typography";
import Button from "themeComponents/Button";

interface EmptyStateCardProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  titleColor?: string;
}

function EmptyStateCard({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  titleColor = "text",
}: EmptyStateCardProps): React.JSX.Element {
  return (
    <Card>
      <Box p={4} textAlign="center" {...({} as any)}>
        {icon && <Box mb={2} {...({} as any)}>{icon}</Box>}
        <Typography variant="h6" color={titleColor} mb={2} {...({} as any)}>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" mb={3} {...({} as any)}>
            {description}
          </Typography>
        )}
        {actionLabel && onAction && (
          <Button variant="gradient" color="info" onClick={onAction}>
            {actionLabel}
          </Button>
        )}
      </Box>
    </Card>
  );
}

export default EmptyStateCard;